export default __webpack_public_path__ + "3670fadc2100014662e0b1aef4dc26de.svg";